import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Ensures every SPA route change starts at the top of the page.
// Uses a triple-tap (immediate + rAF + setTimeout 60ms) to defeat post-mount
// layout shifts caused by lazy images or framer-motion entrance animations.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Fertig gebaute Seite (Snapshot) ist noch sichtbar: Leser nicht nach oben reißen, falls er schon scrollt
    if (window.__SNAP_ACTIVE) return undefined;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    const toTop = () => window.scrollTo(0, 0);
    toTop();
    const raf = requestAnimationFrame(toTop);
    const t = setTimeout(toTop, 60);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [pathname]);

  return null;
}
